import React from "react";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import styles from "./AuthorizePage.module.scss";

type PermissionScope = "read" | "write";

interface PermissionsToggleProps {
    value: PermissionScope;
    onChange: (value: PermissionScope) => void;
    canWrite?: boolean;
}

export const PermissionsToggle: React.FC<PermissionsToggleProps> = ({
    value,
    onChange,
    canWrite = true,
}) => (
    <ToggleGroup.Root<PermissionScope>
        value={value}
        onValueChange={(next) => {
            if (next) {
                onChange(next);
            }
        }}
        size="lg"
        className={styles.permissionsToggle}
    >
        {canWrite && (
            <ToggleGroup.Item
                value="write"
                className={styles.permissionsOption}
            >
                Read &amp; write
            </ToggleGroup.Item>
        )}
        <ToggleGroup.Item value="read" className={styles.permissionsOption}>
            Read only
        </ToggleGroup.Item>
    </ToggleGroup.Root>
);
